import {
  System_URL,
  Branch_Contact_URL,
  Branch_Location_Pincode_URL,
  Master_Service_TEAMS_URL,
} from "../Url";
import axios from "axios";
import { clearLogoutData } from "../logout/action";

export const SVMListActions = {
  SVM_LIST: "SVM_LIST",
  SVM_LIST_SUCCESS: "SVM_LIST_SUCCESS",
  SVM_LIST_ERROR: "SVM_LIST_ERROR",
  LOGOUT: "LOGOUT",
};

export function getSVMListTeams(props) {
  const { access_token, name, url } = props;
  let endpoint = "";
  if (url) {
    endpoint = `${System_URL}/get/${url}/${name}`;
  } else {
    endpoint = `${System_URL}/listing/SystemValueMasters`;
  }
  // if(url){
  //       endpoint = `${System_URL}/listing/SystemValueMasters`;
  // }
  return (dispatch) =>
    axios({
      method: "get",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: endpoint,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getSVMListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getSVMListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getSVMListError(err));
          return err.response;
        }
      });
}

export function getSVMListRequest() {
  return {
    type: SVMListActions.SVM_LIST,
    isPosting: true,
  };
}
export function getSVMListError(error) {
  return {
    type: SVMListActions.SVM_LIST_ERROR,
    payload: error,
  };
}

export function getSVMListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: SVMListActions.SVM_LIST_SUCCESS,
      payload: props,
    });
  };
}

export const pincodeListActions = {
  PINCODE_LIST: "PINCODE_LIST",
  PINCODE_LIST_SUCCESS: "PINCODE_LIST_SUCCESS",
  PINCODE_LIST_ERROR: "PINCODE_LIST_ERROR",
  LOGOUT: "LOGOUT",
};

export function getPincodeOnSearch(props) {
  const { access_token, inputValue } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url:
        `${Branch_Location_Pincode_URL}/search/Pincode?pincode=` + inputValue,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getPincodeListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getPincodeListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getPincodeListError(err));
          return err.response;
        }
      });
}

export function getPincodeListRequest() {
  return {
    type: pincodeListActions.PINCODE_LIST,
    isPosting: true,
  };
}
export function getPincodeListError(error) {
  return {
    type: pincodeListActions.PINCODE_LIST_ERROR,
    payload: error,
  };
}

export function getPincodeListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: pincodeListActions.PINCODE_LIST_SUCCESS,
      payload: props,
    });
  };
}

export const getBranchLocationByPincodeActions = {
  GET_BRANCH_LOCATION_BY_PINCODE: "GET_BRANCH_LOCATION_BY_PINCODE",
  GET_BRANCH_LOCATION_BY_PINCODE_SUCCESS:
    "GET_BRANCH_LOCATION_BY_PINCODE_SUCCESS",
  GET_BRANCH_LOCATION_BY_PINCODE_ERROR: "GET_BRANCH_LOCATION_BY_PINCODE_ERROR",
  LOGOUT: "LOGOUT",
};

export function getBranchLocationByPincode(props) {
  const { access_token, url, data, pincode } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },

      url: `${Branch_Location_Pincode_URL}/${url}?pincodeId=` + pincode,
      data: data,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getBranchLocationByPincodeSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getBranchLocationByPincodeError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getBranchLocationByPincodeError(err));
          return err.response;
        }
      });
}

export function getBranchLocationByPincodeRequest() {
  return {
    type: getBranchLocationByPincodeActions.GET_BRANCH_LOCATION_BY_PINCODE,
    isPosting: true,
  };
}
export function getBranchLocationByPincodeError(error) {
  return {
    type: getBranchLocationByPincodeActions.GET_BRANCH_LOCATION_BY_PINCODE_ERROR,
    payload: error,
  };
}

export function getBranchLocationByPincodeSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getBranchLocationByPincodeActions.GET_BRANCH_LOCATION_BY_PINCODE_SUCCESS,
      payload: props,
    });
  };
}

export const getBranchLocationByAreaActions = {
  GET_BRANCH_LOCATION_BY_AREA: "GET_BRANCH_LOCATION_BY_AREA",
  GET_BRANCH_LOCATION_BY_AREA_SUCCESS: "GET_BRANCH_LOCATION_BY_AREA_SUCCESS",
  GET_BRANCH_LOCATION_BY_AREA_ERROR: "GET_BRANCH_LOCATION_BY_AREA_ERROR",
  LOGOUT: "LOGOUT",
};
export function getBranchLocationByArea(props) {
  const { access_token, url, pincode, data } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },

      url: `${Branch_Location_Pincode_URL}/${url}?pincode=` + pincode,
      data: data,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getBranchLocationByAreaSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getBranchLocationByAreaError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getBranchLocationByAreaError(err));
          return err.response;
        } else {
          dispatch(clearLogoutData());
        }
      });
}

export function getLocMasterByAreaRequest() {
  return {
    type: getBranchLocationByAreaActions.GET_BRANCH_LOCATION_BY_AREA,
    isPosting: true,
  };
}
export function getBranchLocationByAreaError(error) {
  return {
    type: getBranchLocationByAreaActions.GET_BRANCH_LOCATION_BY_AREA_ERROR,
    payload: error,
  };
}

export function getBranchLocationByAreaSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getBranchLocationByAreaActions.GET_BRANCH_LOCATION_BY_AREA_SUCCESS,
      payload: props,
    });
  };
}

export function postTeamDetails(props) {
  const { access_token, values, personId } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },

      url: `${Master_Service_TEAMS_URL}/saveTeamAddress?partnerPersonId=${personId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getBranchLocationByAreaSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getBranchLocationByAreaError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getBranchLocationByAreaError(err));
          return err.response;
        }
      });
}

export const CurrentAddressActions = {
  CURRENT_ADDRESS_SUCCESS: "CURRENT_ADDRESS_SUCCESS",
  CURRENT_ADDRESS_ERROR: "CURRENT_ADDRESS_ERROR",
};

export function getCurrentAddressTeams(props) {
  const { access_token, personId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Master_Service_TEAMS_URL}/getCurrentAddress?partnerPersonId=${personId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(
            getCurrentAddressSuccess(
              response.data.partnerTeamPersonMasterAddressDTO
            )
          );
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getCurrentAddressError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getCurrentAddressError(err));
          return err.response;
        }
      });
}

export function getCurrentAddressError(error) {
  return {
    type: CurrentAddressActions.CURRENT_ADDRESS_ERROR,
    payload: error,
  };
}

export function getCurrentAddressSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: CurrentAddressActions.CURRENT_ADDRESS_SUCCESS,
      payload: props,
    });
  };
}

export const PermanentAddressActions = {
  PERMANENT_ADDRESS_SUCCESS: "PERMANENT_ADDRESS_SUCCESS",
  PERMANENT_ADDRESS_ERROR: "PERMANENT_ADDRESS_ERROR",
};

export function getPermanentAddressTeams(props) {
  const { access_token, personId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Master_Service_TEAMS_URL}/getPermanentAddress?partnerPersonId=${personId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(
            getPermanentAddressSuccess(
              response.data.partnerTeamPersonMasterAddressDTO
            )
          );
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getPermanentAddressError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getCurrentAddressError(err));
          return err.response;
        }
      });
}

export function getPermanentAddressError(error) {
  return {
    type: PermanentAddressActions.PERMANENT_ADDRESS_ERROR,
    payload: error,
  };
}

export function getPermanentAddressSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: PermanentAddressActions.PERMANENT_ADDRESS_SUCCESS,
      payload: props,
    });
  };
}
